import { ApolloClient, createHttpLink ,ApolloLink,from, HttpLink,  InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { RetryLink } from '@apollo/client/link/retry';
import { onError } from '@apollo/client/link/error';


//Models
import AcreditacionProfile from './models/AcreditacionProfile'
import AcreditationUser from './models/AcreditationUser'

// Apollo auth & client
const authMiddleware = new ApolloLink((operation, forward) => {
    let token = AcreditationUser.getToken();  
    if(!token)
        token = AcreditacionProfile.getToken();  

    operation.setContext(({ headers = {} }) => ({
        headers: {
            ...headers,
            authorization: token?`Bearer ${token}`:'',
            'x-api-key': process.env.REACT_APP_API_KEY,
        },
    }));
  
    return forward(operation);
});

const logoutLink = onError((errorResponse) => {
    if (['TOKEN_EXPIRED', 'TOKEN_INVALID'].includes(errorResponse.graphQLErrors?.[0]?.code)) {
        AcreditacionProfile.logOut();
        window.location.href = '/';
    }
});
  
const directionalLink =new  HttpLink({ uri: (operation) => {
    if(operation.getContext().clientName === 'LOGIN')
        return process.env.REACT_APP_LOGIN_GRAPHQL_URL;
    else if(operation.getContext().clientName === 'SITE')
        return process.env.REACT_APP_WEBSITE_GRAPHQL_URL;
    else
        return process.env.REACT_APP_GRAPHQL_URL ;
}});


export default new ApolloClient({
    link: from([
        authMiddleware,
        logoutLink,
        directionalLink,
    ]),
    cache: new InMemoryCache({ dataIdFromObject: () => null }),
    connectToDevTools: true,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
            errorPolicy: 'all',
        },
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        },
        mutate: {
            errorPolicy: 'all'
        }  
    },  
});